// extracted by mini-css-extract-plugin
module.exports = {"restaurantContainer":"Restaurant_restaurantContainer__5k5In","restaurantHeader":"Restaurant_restaurantHeader__SrWmy","businessInfo":"Restaurant_businessInfo__BDLN_"};